import { ChequeGiroClearingModel } from 'api-hooks/transactions/cheque-giro-clearing';
import React from 'react';

import { ChequeGiroClearingFormType } from '../components/form-type';

export default function useGetDefaultValues(
  chequeGiroClearing?: ChequeGiroClearingModel,
) {
  const defaultValues = React.useMemo<ChequeGiroClearingFormType>(() => {
    return {
      chequeGiro: chequeGiroClearing?.chequeGiro.id || null,
      type: chequeGiroClearing?.type || '',
      referenceNumber: chequeGiroClearing?.referenceNumber || '',
      issuedAt: chequeGiroClearing?.issueAt || new Date(),
      availableAt: chequeGiroClearing?.availableAt || new Date(),
      expiredAt: chequeGiroClearing?.expiredAt || new Date(),
      status: chequeGiroClearing?.status || '',
      bankAccount: chequeGiroClearing?.bankAccount.id || null,
      chequeNoteClearings:
        chequeGiroClearing?.chequeNoteClearings?.map((item) => ({
          status: item.status,
          clearingAt: item.clearingAt,
          order: item.order,
          createdBy: item.createdBy?.name ?? '',
          id: item.id,
        })) || [],
    };
  }, [chequeGiroClearing]);

  return defaultValues;
}
